import { render, staticRenderFns } from "./InfoOpeningHours.vue?vue&type=template&id=7bdebd66&scoped=true&"
import script from "./InfoOpeningHours.vue?vue&type=script&lang=js&"
export * from "./InfoOpeningHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdebd66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bdebd66')) {
      api.createRecord('7bdebd66', component.options)
    } else {
      api.reload('7bdebd66', component.options)
    }
    module.hot.accept("./InfoOpeningHours.vue?vue&type=template&id=7bdebd66&scoped=true&", function () {
      api.rerender('7bdebd66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/DmVisualizer/Components/ChangeInfo/InfoOpeningHours.vue"
export default component.exports